import './css.js';

async function init() {
    await import('../../assets/unify/plugins/back-to-top.js');
    await import('../../assets/unify/plugins/owl-carousel/owl-carousel/owl.carousel.js');
    let text = await import('../../public/locales/'+locale+'/hotel.json');
    const moment = await import('moment');
    const login = await import('../../assets/custom/js/user/login.js');
    const OwlCarousel = await import(/* webpackChunkName: "owlCarousel" */ '../../assets/unify/js/plugins/owl-carousel.js');
    $(document).ready(function() {
        OwlCarousel.initOwlCarousel();
    });

    $(function () {
        $('#change-room').change(function (event) {  //房型庫存頁面切換房型
            window.location = urlPrefix + '/room/'+$("#change-room").val();
        });

        function fetchInventory(cb) {
            let that = this;
            that.isLoading = true;
            that.checkInDate = '';
            $.ajax(urlPrefix + '/room/inventory/' + roomNo, {
                type: 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                data: {
                    'year': that.calendar.year,
                    'month': that.calendar.month,
                    'room-qty': that.roomQty,
                    'nights': that.nights
                },
                dataType: 'json',
                success: function(res) {
                    if (true === res.status) {
                        if (true === res.waiting) {
                            that.waiting_on = res.waiting;
                        }
                        let row = that.calendarRow;
                        let inventory = [];
                        let inventoryWeek;
                        for (let i = 0; i <= row; i++) {
                            inventoryWeek = [];
                            for (let j = (7*i); j < (7*(i+1)); j++) {
                                if(j < that.calendar.firstDateDay) {
                                    inventoryWeek.push({
                                        current: false
                                    });
                                } else if (j - that.calendar.firstDateDay >= that.calendar.endDate) {
                                    inventoryWeek.push({
                                        current: false
                                    });
                                } else {
                                    inventoryWeek.push({
                                        date: moment(res.inventory[j - that.calendar.firstDateDay].date),
                                        price: res.inventory[j - that.calendar.firstDateDay].price,
                                        qty: res.inventory[j - that.calendar.firstDateDay].qty,
                                        available: res.inventory[j - that.calendar.firstDateDay].available,
                                        applicable: res.inventory[j - that.calendar.firstDateDay].applicable,
                                        isAfter: moment(res.inventory[j - that.calendar.firstDateDay].date).isSameOrAfter(moment().format('YYYY-MM-DD'), 'day'),
                                        current: true
                                    });
                                }
                            }
                            inventory.push(inventoryWeek);
                        }
                        that.inventory = inventory;
                    } else {
                        alert(res.message);
                        cb();
                    }
                    that.isLoading = false;
                }
            });
        }

        if (document.getElementById('vue-room') !== null) {
            let firstDay = moment(firstSaleDay);
            let calendarInitDate = firstDay; //第一天有放房之後的日期才可以訂房

            let vm = new Vue({
                el: '#vue-room',
                data: {
                    nights: 1,
                    roomQty: 1,
                    calendar: {
                        firstDay: firstDay,
                        year: calendarInitDate.year(),
                        month: calendarInitDate.month() + 1,
                        firstDateDay: calendarInitDate.startOf('month').day(),
                        endDate: calendarInitDate.endOf('month').date()
                    },
                    waiting_on: false,
                    inventory: [],
                    checkInDate: '',
                    isWaiting: 0,
                    isLoading: false,
                    nextLoading: false
                },
                created: function () {
                    // 先抓取第一個月份的庫存
                    fetchInventory.call(this);
                },
                computed: {
                    calendarRow: function() {
                        return Math.ceil((this.calendar.endDate + this.calendar.firstDateDay) / 7) - 1;
                    },
                    currentMonth: function() {
                        return this.calendar.firstDay.isSame(moment([this.calendar.year, this.calendar.month - 1]), 'month');
                    },
                    checkInDateSend: function() {
                        if (this.checkInDate instanceof moment) {
                            return this.checkInDate.format('YYYY-MM-DD');
                        }
                        return '';
                    }
                },
                methods: {
                    prev: function () {
                        var changeDate = moment([this.calendar.year, this.calendar.month - 1])
                            .subtract(1, 'months');
                        if (changeDate.isSameOrAfter(moment().format('YYYY-MM-DD'), 'month')) {
                            this.calendar.year = changeDate.year();
                            this.calendar.month = changeDate.month() + 1;
                            this.calendar.firstDateDay = changeDate.startOf('month').day();
                            this.calendar.endDate = changeDate.endOf('month').date();
                            fetchInventory.call(this, this.next);
                        } else {
                            alert(text.SystemText.NotFurther);
                        }
                    },
                    next: function () {
                        let changeDate = moment([this.calendar.year, this.calendar.month - 1])
                            .add(1, 'months');
                        this.calendar.year = changeDate.year();
                        this.calendar.month = changeDate.month() + 1;
                        this.calendar.firstDateDay = changeDate.startOf('month').day();
                        this.calendar.endDate = changeDate.endOf('month').date();
                        fetchInventory.call(this, this.prev);
                    },
                    selectRoomQty: function () {
                        this.checkInDate = '';
                        fetchInventory.call(this, function(){});
                    },
                    selectNights: function () {
                        this.checkInDate = '';
                        fetchInventory.call(this, function(){});
                    },
                    selectCheckInDate: function (date, isWaiting, event) {
                        let this$ = $(event.target).closest('a');
                        this$.focus();
                        this.checkInDate = date;
                        this.isWaiting = isWaiting || 0;
                    },
                    backList: function () {
                        window.location = urlPrefix + '/room/list';
                    },
                    submitNext: function(event) {
                        let that = this;
                        if (that.checkInDate instanceof moment) {
                            that.nextLoading = true;
                            let form$ = $('#room-submit-form');
                            login.check(function (err, status, userInfo) {
                                if (status === true) {
                                    form$.submit();
                                } else {
                                    if(enableMember === true){
                                        that.nextLoading = false;
                                        login.initModal($(event.target), function(target){
                                            that.nextLoading = true;
                                            form$.submit();
                                        }, !!that.isWaiting);
                                    }else{
                                        form$.submit();
                                    }
                                }
                            });
                        } else {
                            alert(text.SystemText.SelectDate);
                        }
                    }
                }
            });
        }

    });

    $('.readmore').click(function (event){
        let that$ = $(this);
        that$.closest('div.text-content').find('div.texthide').removeClass('texthide').addClass('showmore').end().find('div.overtext').remove();
        that$.remove();
    });

    // 2022-05-31 野漾莊園一般訂房增加公告
    $(document).ready(function () {
        $('#autoNotice').get(0).click();
    });

    $('#Notice-remember').on('change', function () {
        $.ajax(urlPrefix + '/api/index/notice', {
            type: 'post',
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr('content')
            }
        });
    })
}

init();


// WEBPACK FOOTER //
// ./webpack/room/entry.js